(function () {
  var storageKey = 'walspro-color-scheme';
  var root = document.documentElement;
  var mediaQuery = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
  var toggle = document.querySelector('[data-color-scheme-toggle]');
  var toggleText = document.querySelector('[data-color-scheme-toggle-text]');

  function getStoredScheme() {
    try {
      return window.localStorage.getItem(storageKey);
    } catch (error) {
      return null;
    }
  }

  function storeScheme(scheme) {
    try {
      window.localStorage.setItem(storageKey, scheme);
    } catch (error) {
      return;
    }
  }

  function getSystemScheme() {
    return mediaQuery && mediaQuery.matches ? 'dark' : 'light';
  }

  function setScheme(scheme) {
    root.setAttribute('data-color-scheme', scheme);

    if (!toggle) {
      return;
    }

    var isDark = scheme === 'dark';
    var label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

    toggle.setAttribute('aria-pressed', isDark ? 'true' : 'false');
    toggle.setAttribute('aria-label', label);

    if (toggleText) {
      toggleText.textContent = label;
    }
  }

  setScheme(getStoredScheme() || getSystemScheme());

  if (toggle) {
    toggle.addEventListener('click', function () {
      var nextScheme = root.getAttribute('data-color-scheme') === 'dark' ? 'light' : 'dark';
      storeScheme(nextScheme);
      setScheme(nextScheme);
    });
  }

  if (mediaQuery && mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', function (event) {
      if (!getStoredScheme()) {
        setScheme(event.matches ? 'dark' : 'light');
      }
    });
  }
})();
